import React from 'react'
import { index, change } from '../../../store/actions/metrics.action'
import { CircularProgress, TextField, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import { FcTreeStructure, FcComboChart, FcMoneyTransfer, FcAcceptDatabase, FcBusinessman , FcBarChart} from 'react-icons/fc'
import { MdKeyboardBackspace } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import VerifySms from '../../components/VerifySms'

export default function Metrics(props) {
    const dispatch = useDispatch()
    const action_id = (props.uid) ? props.uid : null;
    const link_id = (props.link_id) ? props.link_id : null;

    const { open, screen_id } = useSelector(state => state.smsReducer)
    const { metric } = useSelector(state => state.metricsReducer)

    const [isLoad, setLoad] = React.useState(true)
    const [isLoading, setLoading] = React.useState(true)
    const date = new Date();
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [dateInitial, setDateInitial] = React.useState(dateInit);
    const [dateFinal, setDateFinal] = React.useState(dateEnd);

    React.useEffect(() => {
        return () => {
            dispatch(change('clear'))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        _index()
    }, [dateInitial, dateFinal])

    const _index = () => {
        setLoad(true)
        dispatch(index(action_id, link_id, new Date(dateInitial), new Date(dateFinal))).then(() => {
            setLoad(false)
            setLoading(false)
        })
    }

    return (
        <>
            <VerifySms 
                type="login_code"
                open={screen_id === 'metrics.index' && open}
                onConfirm={() => {
                    _index()
                }}
                onClose={() => window.location.replace('/')}
            />
            <div className="app-bar">
                <AppBar position="fixed">
                    <Toolbar>
                        <IconButton onClick={() => link_id ? dispatch(changeScreenB({ open: false })) : dispatch(changeScreen({ open: false })) } edge="start" color="inherit">
                            <MdKeyboardBackspace />
                        </IconButton>
                        <Typography variant="h6">
                            Métricas
                        </Typography>
                    </Toolbar>
                </AppBar>
                
                {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                <div className="card p-3 mt-3 mb-2 bs-bg">
                    <label className="fw-bold label-custom bs-color-b"><FcComboChart size={20} className="me-2" />Métricas</label>
                    
                    <div className="row mt-2">
                        <div className="col-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateInitial))}&nbsp;&nbsp;&nbsp;
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateInitial))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Inicial"
                                    type="datetime-local"
                                    defaultValue={dateInitial}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={e => {
                                        if(e.target.value) {
                                            setDateInitial(e.target.value)
                                        } else {
                                            setDateInitial(dateInit)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateFinal))}&nbsp;&nbsp;&nbsp;
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateFinal))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Final"
                                    type="datetime-local"
                                    defaultValue={dateFinal}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={e => {
                                        if(e.target.value) {
                                            setDateFinal(e.target.value)
                                        } else {
                                            setDateFinal(dateEnd)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                {(isLoad) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                    <>
                    
                    <div className="card p-3 mt-3 mb-2 bs-bg">
                        <div className="row">
                            <div className="col">
                                <label className="fw-bold label-custom bs-color-b"><FcMoneyTransfer size={20} className="me-2" />Valor Liquido</label>
                                
                                <div className="card-body">
                                    <h2 className="bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(metric.total_amount)}</h2>
                                </div>
                            </div>

                            <div className="col">
                                <label className="fw-bold label-custom bs-color-b"><FcTreeStructure size={20} className="me-2" />Cotas</label>
                                    
                                <div className="card-body">
                                    <h2 className="bs-color-b">{metric.total_cotas.toLocaleString('pt-BR', {style: 'decimal'})}</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card p-3 mt-3 mb-2 bs-bg">
                        <div className="row">
                            <div className="col">
                                <label className="fw-bold label-custom bs-color-b"><FcAcceptDatabase size={20} className="me-2" />Transações pagas</label>
                                    
                                <div className="card-body">
                                    <h2 className="bs-color-b">{metric.total_transaction.toLocaleString('pt-BR', {style: 'decimal'})}</h2>
                                </div>
                            </div>
                            
                            <div className="col">
                                <label className="fw-bold label-custom bs-color-b"><FcBarChart size={20} className="me-2" />Média</label>
                                    
                                <div className="card-body">
                                    <h2 className="bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(metric.gasto_transaction)}</h2>
                                </div>
                            </div>
                        </div>
                        
                        <hr className="hr-muted"/>

                        <div className="row">
                            <div className="col">
                                <label className="fw-bold label-custom bs-color-b"><FcBusinessman size={20} className="me-2" />Compradores</label>
                                    
                                <div className="card-body">
                                    <h2 className="bs-color-b">{metric.total_user.toLocaleString('pt-BR', {style: 'decimal'})}</h2>
                                </div>
                            </div>

                            <div className="col">
                                <label className="fw-bold label-custom bs-color-b"><FcBarChart size={20} className="me-2" />Gasto médio</label>
                                    
                                <div className="card-body">
                                    <h2 className="bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(metric.gasto_medio)}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
                }
                </>
                }
            </div>
        </>
    )
}